import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import { IEditCallbacksPayload } from "@app/dashboard/types/innerLayout/payment_integrations/edit-integrations";

export const editPaymentIntegration = ({
  integrationId,
  payload,
}: {
  integrationId: string | number;
  payload: IEditCallbacksPayload
}) => {

  const {
    integration_name,
    transaction_response_callback,
    transaction_processed_callback,
  } = payload;

  return axiosPrivate.put(`/dashboard/api/v1/integrationsv1/${integrationId}`, {
    ...(integration_name && { integration_name }),
    transaction_response_callback,
    transaction_processed_callback,
  });
};
